import { render, staticRenderFns } from "./WithdrawalInfoForm.vue?vue&type=template&id=210984b0&"
import script from "./WithdrawalInfoForm.vue?vue&type=script&lang=js&"
export * from "./WithdrawalInfoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports